export const AI_LAYOUT_TEXT = {
    BACK: 'Back',
    BODY:
        'Body copy goes here. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa.',
    NEXT: 'Next',
    PRIMARY_CTA: 'Primary CTA',
    SECONDARY_CTA: 'Secondary CTA',
    STEP_X_OF_Y: 'STEP X OF Y',
    SUBTITLE: 'SUBTITLE',
    TITLE: 'Title line',
    EMBEDDED_TITLE: 'Banner',
};

export const AI_MOBILE_LAYOUT_TEXT = {
    BODY:
        'Body copy goes here. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa.',
    PRIMARY_CTA: 'Primary CTA',
    TITLE: 'Title line',
};
